import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';

import cl from './Contacts.module.css';
import { animateScroll as scroll } from 'react-scroll';
import bag from '../../image/handmade-paper-bags.webp';

const Contacts = (props) => {
  useEffect(() => {
    scroll.scrollToTop();
  }, []);
  const position = props.coordinates?.split(', ') || [40.4369192, -3.6822881];

  return (
    <section className={cl.contact}>
      <div className={cl.main}>
        <div className={cl.contacts}>
          <h1 className={cl.title}>Contactos</h1>
          <div className={cl.wrapper}>
            <div>
              <p>{props.shopName}</p>
              <p>{props.address}</p>
              <p>
                Tel:{' '}
                <a href="tel:123-456-7890" className={cl.link}>
                  123-456-7890
                </a>
              </p>
              <p>
                Email:{' '}
                <a href={'mailto: support@' + props.domain} className={cl.link}>
                  support@{props.domain}
                </a>
              </p>
            </div>
            <MapContainer
              center={position}
              zoom={12}
              scrollWheelZoom={false}
              style={{ height: '200px', width: '220px', margin: '10px' }}
            >
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              <Marker position={position} />
            </MapContainer>
          </div>
          <div style={{ marginTop: '60px' }}>
            <p style={{ fontSize: '28px', marginBottom: '20px' }}>
              Horario de Apertura
            </p>
            <p style={{ marginBottom: '20px' }}>
              Lunes - Viernes: 7:00 - 22:00
            </p>
            <p style={{ marginBottom: '20px' }}>Sábado: 8:00 - 22:00</p>
            <p style={{ marginBottom: '20px' }}>Domingo: 8:00 - 23:00</p>
          </div>
          <div style={{ width: '10vw', alignSelf: 'center' }}>
            <img
              style={{ width: '100%', height: 'auto' }}
              src={bag}
              alt="bags"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contacts;
